// Generato automaticamente prima di ogni compilazione. Non modificare a mano.
export const VERSIONE_BUILD = 'Build 2026.11.01-151042';
export const DATA_VERSIONE_BUILD = '01/11/2026 · 15:10';
